import { createAsyncThunk } from '@reduxjs/toolkit';
import Raven from 'raven-js';
import { getThreadWithMessages } from '../api/threadsApi';
export const copilotV2GetThreadWithMessages = createAsyncThunk('threads/copilotV2GetThreadWithMessages',
// TODO - @mlegocki: update this to work with new chat/thread V2 redux pattern
async (args, {
  rejectWithValue
}) => {
  try {
    return await getThreadWithMessages(args);
  } catch (error) {
    Raven.captureException(error instanceof Error ? error : new Error(String(error)), {
      extra: {
        component: 'copilotV2GetThreadWithMessages',
        action: 'copilotV2GetThreadWithMessages',
        copilotVersion: '2'
      }
    });
    return rejectWithValue(error instanceof Error ? error.message : `Failed to get specific thread: ${args.threadId}`);
  }
});